import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "../css/featureDetail.css";

const AboutCustomers = () => (
  <>
    <Helmet>
      <title>50,000+ Happy Customers — Trusted Nationwide | Salary Uncle</title>
      <meta name="description" content="Over 50,000 salaried professionals across India trust Salary Uncle for instant loans. 4.8/5 rating, 80% repeat customers." />
    </Helmet>

    <section className="fd-hero">
      <div className="fd-hero-inner">
        <Link to="/about-us" className="fd-back">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
          Back to About
        </Link>
        <div className="fd-hero-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
        </div>
        <span className="fd-tag">TRUSTED NATIONWIDE</span>
        <h1>50,000+ Happy Customers</h1>
        <p>Over 50,000 salaried professionals from every industry trust Salary Uncle — bound by our commitment to speed, transparency, and care.</p>
      </div>
    </section>

    <section className="fd-body">
      <div className="fd-body-inner">
        <div className="fd-highlights">
          {[
            { title: "4.8/5 Customer Rating", desc: "Consistently rated 4.8 out of 5 across Google, Trustpilot, and app stores." },
            { title: "80% Repeat Customers", desc: "Most customers come back — proof that our service builds long-term trust." },
            { title: "Every Industry Served", desc: "IT, banking, government, healthcare, retail — we serve salaried pros from every field." },
            { title: "Dedicated Support", desc: "Real human support team available Mon–Sat, 9 AM–7 PM, via phone, email & WhatsApp." },
            { title: "AI Chatbot Myra", desc: "24/7 instant answers from Myra, our AI assistant — always there when you need help." },
            { title: "Thousands of Reviews", desc: "Read real stories from real customers — every review is verified and unedited." },
          ].map((h, i) => (
            <div className="fd-highlight-card" key={i}>
              <div className="fd-hl-num">{String(i + 1).padStart(2, "0")}</div>
              <div>
                <div className="fd-hl-title">{h.title}</div>
                <div className="fd-hl-desc">{h.desc}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="fd-steps-box">
          <h2>Why Customers Choose Us</h2>
          <div className="fd-steps">
            {[
              { step: "1", text: "Lightning-fast approval — no waiting for days." },
              { step: "2", text: "Zero hidden charges — every fee disclosed upfront." },
              { step: "3", text: "Friendly, jargon-free communication at every step." },
              { step: "4", text: "Flexible repayment options that respect your cash flow." },
              { step: "5", text: "Real support from real people — not bots that can't help." },
            ].map((s, i) => (
              <div className="fd-step-row" key={i}>
                <div className="fd-step-dot">{s.step}</div>
                <div className="fd-step-text">{s.text}</div>
              </div>
            ))}
          </div>
          <Link to="/apply-now" className="fd-cta-btn">Apply Now</Link>
        </div>
      </div>
    </section>
  </>
);

export default AboutCustomers;
